import React from 'react'
import { loadAnalytics } from '../../../globals/load-analytics'

class Cookie extends React.Component {
  componentDidMount() {
    loadAnalytics(this.props.companyId)
  }

  render() {
    return null
  }
}

export default Cookie
